<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="centerImage"><img alt="images" id="img4" src="images/img4.jpg"/></p>
<p class="caption">Delegates’ Convention of the National Indian War Veterans in St. Joseph, Missouri, 1927. George W. Webb is seated in front center, with cane. To his right is his wife and ladies’ auxiliary national leader, Lorena Jane Webb. To his left is NIWV National Adjutant General Albert Fensch. Fensch was a leader in the walkout the next year that led to the founding of the United Indian War Veterans.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// IndianWarVeterans_introduction5.vue?7f08a9e0